<div class=" is-display">
  <img src="{{imgurl}}" alt="" (click)="modalDismiss()">
</div>
<div class="div-btn-close" (click)="modalDismiss()">
  <ion-icon name="close-circle-outline"></ion-icon>
</div>